import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=c9603f60&scoped=true&"
import script from "./dispatch.vue?vue&type=script&lang=js&"
export * from "./dispatch.vue?vue&type=script&lang=js&"
import style0 from "./dispatch.vue?vue&type=style&index=0&id=c9603f60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9603f60",
  null
  
)

export default component.exports